import { isEmpty } from 'lodash-es';

// Check if the value is empty
export const checkNotEmpty = (value: unknown) =>
  // eslint-disable-next-line eqeqeq
  value === '' || value === undefined || value === null || isEmpty(value);

// Check if the value is not empty
export const checkEmpty = (value: unknown) => !isEmpty(value);

export const greaterThan = (value: number, comparator: number) => value > comparator;

// Check if a valid date with format MM/DD/YYYY
export const validDate = (value: string) => {
  const dateValidationRegex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
  if (!dateValidationRegex.test(value)) return false;
  const [m, d, y] = value.split('/').map((n) => Number(n));
  return m === Number(new Date(y, m - 1, d).getMonth()) + 1 && d === Number(new Date(y, m - 1, d).getDate());
};

export const equal = (a: unknown, b: unknown) => a === b;

export const notEqual = (a: unknown, b: unknown) => !equal(a, b);

export const isNull = (a: unknown) => checkNotEmpty(a);

export const isNotNull = (a: unknown) => !isNull(a);

export const isIn = <T>(a: T, b: T[]) => b.indexOf(a) > -1;

export const isNotIn = <T>(a: T, b: T[]) => !isIn(a, b);

export const greaterThanOrEquals = (value: number, comparator: number) => value >= comparator;
export const lessThanOrEquals = (value: number, comparator: number) => value <= comparator;
export const startsWith = (value: unknown, comparator: string) => String(value).startsWith(comparator);
export const contains = (value: unknown, comparator: string) => String(value).includes(comparator);
